import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Col, Container, Row } from 'react-bootstrap'
import { getMobileApplicationPageContent } from '../../actions/cms'
import SendMoney from '../../components/SendMoney/SendMoney'
import config from '../../config/cms'
import Loader from '../../components/Loader/Loader'
import Opinions from '../../components/Opinions/Opinions'
import Banner from '../../components/Banner/Banner'

import '../../styles/pages/MobileApplicationPage/MobileApplicationPageStyle.css'
import isEmpty from '../../utils/isEmpty'
import HelmetTag from '../../utils/HelmetTag'

const MobileApplicationPage = () => {
  const dispatch = useDispatch()
  const lang = useSelector((state) => state.lang.lang)
  const [shouldVideoDisplay, setShouldVideoDispaly] = useState(false)
  const productRef = useRef()

  useEffect(() => {
    dispatch(getMobileApplicationPageContent())
  }, [lang, dispatch])

  const pageContent = useSelector((state) => state.cms.mobileApplicationPage)

  if (isEmpty(pageContent)) {
    return <Loader />
  }

  return (
    <main className="main">
      <HelmetTag pageTitle={pageContent.metaTitle} />
      <Banner bannerData={pageContent?.banner} productRef={productRef} />
      <section ref={productRef}>
        <Container className="my-3 my-lg-4 pt-lg-2">
          <h2 className="title title-center title-with-icon">
            <i className="material-icons text-primary title-icon">mobile_screen_share</i>
            {pageContent?.stepsTitle}
          </h2>
          <Row>
            {pageContent?.steps?.map((step) => (
              <Col key={step.id} md={4} className="mb-3">
                <div className="h-100 shadow rounded p-3 text-center">
                  <i className="material-icons product-icon">{step.icon}</i>
                  <div>{step.description}</div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      <section>
        <Container className="my-4 my-lg-5">
          <Row>
            {pageContent?.movieUrl && (
              <Col md={7} lg={8}>
                <div className="video-wraper">
                  {shouldVideoDisplay ? (
                    <iframe
                      title="mobile-video"
                      width="100%"
                      height="100%"
                      allowFullScreen
                      aria-hidden="true"
                      src={pageContent?.movieUrl}
                    />
                  ) : (
                    <div
                      className="video-thumbnail"
                      style={{
                        backgroundImage: `url(${config.url}${pageContent?.movieCover?.url})`
                      }}
                      onClick={() => setShouldVideoDispaly(true)}
                      onKeyDown={() => setShouldVideoDispaly(true)}
                      role="button"
                      tabIndex={0}
                    />
                  )}
                </div>
              </Col>
            )}
            <Col md={pageContent?.movieUrl ? 5 : 12} lg={pageContent?.movieUrl ? 4 : 12}>
              <div
                className="text-center p-3 shadow rounded h-100 d-flex flex-column align-items-center
                  justify-content-center"
              >
                <h2 className="qrcode-title mb-4 h3">{pageContent?.qrCodeTitle}</h2>
                <img
                  alt={pageContent?.qrCode?.alternativeText}
                  src={`${config.url}${pageContent?.qrCode?.url}`}
                  className="qrcode"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section>
        <Container className="my-3 my-lg-4">
          <SendMoney content={pageContent?.features} />
        </Container>
      </section>
      <section className="py-3 py-lg-4 bg-light border-top">
        <Container className="my-3 my-lg-4">
          <h2 className="title title-center text-center">{pageContent?.canDoTitle}</h2>
          <Row>
            {pageContent?.canDoList?.map((canDoItem) => (
              <Col sm={6} md={4} lg={4} key={canDoItem.id} className="text-center can-do p-3">
                <i className="material-icons mb-2 can-do-icon">{canDoItem.icon}</i>
                <h3 className="can-do-title h5">{canDoItem.title}</h3>
                {canDoItem.description}
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      <section className="bg-white py-2">
        <Opinions />
      </section>
    </main>
  )
}

export default MobileApplicationPage
